var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTime01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16.019px",
    height: "16.018px",
    viewBox: "79.017 120.074 16.019 16.018",
    enableBackground: "new 79.017 120.074 16.019 16.018",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#13392B",
    d: "M87.027,120.074c-4.417,0-8.01,3.593-8.01,8.009s3.593,8.009,8.01,8.009c4.415,0,8.009-3.593,8.009-8.009 S91.442,120.074,87.027,120.074z M87.027,135.101c-3.87,0-7.019-3.148-7.019-7.019s3.148-7.019,7.019-7.019 s7.018,3.148,7.018,7.019S90.897,135.101,87.027,135.101z M87.768,122.055h-0.99v6.936h4.954V128h-3.964V122.055z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTime01);
export default __webpack_public_path__ + "static/media/icon_time-01.8e772bda6f46e4df2292fda6bbc97c40.svg";
export { ForwardRef as ReactComponent };